import type { LabelPrintMarginSettings, PrinterModelPreset } from "./types.js";

/**
 * Presets calibrés par modèle d'imprimante.
 * Le premier preset dont `match` correspond au nom/driver est proposé à l'utilisateur.
 */
export const PRINTER_MODEL_PRESETS: PrinterModelPreset[] = [
  {
    id: "4barcode-4b-2074g-60x40-180",
    match: "4BARCODE",
    label: "4BARCODE 4B-2074G — 60×40 mm (rouleau 180 mm)",
    formatId: "60x40-180",
    rotation: 0,
    margins: {
      marginLeftMm: 9,
      marginTopMm: 7,
      brandZoneMm: 15,
      contentMarginMm: 1,
      rollWidthMm: 180,
      rollOffsetFactor: 8 / 60,
    },
  },
  {
    id: "thermal-generic-58x40",
    match: ".*",
    label: "Thermique générique — 58×40 mm",
    formatId: "58x40",
    rotation: 0,
    margins: {
      marginLeftMm: 2,
      marginTopMm: 2,
      contentMarginMm: 2,
    },
  },
];

export function matchPrinterModelPreset(
  printerName: string,
  driverName?: string,
): PrinterModelPreset | undefined {
  const haystack = `${printerName} ${driverName ?? ""}`.toUpperCase();
  for (const preset of PRINTER_MODEL_PRESETS) {
    if (preset.match === ".*") continue;
    if (haystack.includes(preset.match.toUpperCase())) {
      return preset;
    }
  }
  return PRINTER_MODEL_PRESETS.find((p) => p.match === ".*");
}

export function normalizePrinterKey(printerName: string): string {
  return printerName.trim().toLowerCase();
}

export function emptyMarginSettings(): LabelPrintMarginSettings {
  return {};
}

export function mergeMarginSettings(
  base?: LabelPrintMarginSettings,
  patch?: LabelPrintMarginSettings,
): LabelPrintMarginSettings {
  return { ...base, ...patch };
}
